import {useNavigate, useParams} from "react-router";
import Editor from "@/pages/editor/Editor.tsx";
import {useEffect, useState} from "react";
import axios from "axios";
import {now} from "lodash";

export default function EditorPage() {
    const params = useParams();
    const documentId = params.id;
    const [initialValues, setInitialValues] = useState(null);
    const [attachments, setAttachments] = useState<Attachment[]>([]);
    const navigate = useNavigate()
    const defaultValues = {
        "contact": {
            name: "",
            email: "",
        },
        "way_of_taxation": "tao",
        "meeting_date": new Date(),
        "kelt": new Date(),
        "theme": {},
        "boritok": {premium: true},
        "bizalmiIndex": false,
        "lojalitasArray": [{valuta: {value: 100000, valuta: "HUF"}}],
        "valutaArray": [{valuta: {value: 100000, valuta: "HUF"}}],
        "hozam": "7.415",
        "tanulmany_dij": {value: 130000, valuta: "HUF"},
        "torzsgardaArray": [{value: {value: 100000, valuta: 'HUF'}, mode: true, years: "10"}],
        "meetingSummary": {
            "intro": "<p>A 2000. január 1-én Proba Péter Úrral a Proba Kft. tulajdonosával történt találkozón beszélgettünk az angolszász vállalkozási tapasztalatokról, humánerő kérdéskörről, a tulajdonosi tőkeképzésről, mint pénzkivételi lehetőségről és szindikátusi rendszerrel kapcsolatos kérdésekről. A stratégia felépítését a beszélgetésen kapott információkra támaszkodva alakítottuk ki, ahol figyelembe vettük az vállalkozásokról kapott információkat, melyek a következők:</p>",
            "topics": "<p>- a vállalkozás az elmúlt években kialakított és felépített stratégia alapján működik,</p>\n" +
                "\n" +
                "<p>- a vállalkozás kiegyensúlyozott, növekedési forgalmi pályán van, stabil pénzügyi helyzete van</p>\n" +
                "\n" +
                "<p>- a vállalkozás kft. formában működik – normál adózás</p>",
            "subject_richtext": "<p>A beszélgetés, két fő téma köré épült:</p>\n" +
                "\n" +
                "<p>Az első témakör a humánerőforrás-gazdálkodás volt, ahol Anikó és József is elmondta, hogy nem könnyű megfelelő munkatársat találni, illetve, hogy a régi munkatársak megtartása is komoly energiát igényel. Több olyan stratégiai munkatárs is van, akiknek a munkájára hosszútávon számítanak. Kitértünk a munkatársak megtartásának lehetőségére, ahol átbeszélésre kerültek azok a folyamatok, melyek a munkatársak döntési mechanizmusait vezényelik. Ennek megfelelően bemutatásra került egy olyan metódus, mely egyben kezeli az emberi tényezőket és nem okoz eredmény nélküli kiadást a vállalatnak. Miután átbeszéltük a folyamatokat és ismertettük a rendszerünket, abban egyeztünk meg, hogy készítsünk egy számsort a megtartási programra. Abban állapodtunk meg, hogy 100eFt/hó/fő összegre készítjük az ajánlatot, melyből szabadon tudnak differenciálni. A kimutatást bruttósítva készítettük el. József nagyjából 4-5 főben gondolkodik első körben.</p>\n" +
                "\n" +
                "<p>A második témakör a vállalkozásból való tulajdonosi tőkeképzés volt. Itt abban maradtunk, hogy saját maguk részére 300 eFt/fő elhelyezését tudják elképzelni.</p>\n" +
                "\n" +
                "<p>A harmadik témakör az öröklés kérdése volt. A téma kibontásánál átbeszélésre került, hogy abban az esetben, ha József elhalálozik, úgy az Ő üzletrésze mértékéig a lánya fog beállni a cégbe, mint örökös. A beszélgetésen kibontott helyzet taglalásakor, mind Anikó, mind József úgy nyilatkozott, hogy mivel József örököse nem vesz részt operatíve a cég működésében, így nem szeretnék, ha a cég üzletrésze rá szálljon. Anikó és József is egyöntetűen úgy nyilatkozott, hogy abban az esetben, ha József elhalálozik, úgy az üzletrész Anikó érdekkörnyezetében maradjon.</p>"

        }

    }

    useEffect(() => {
        axios.get(`/api/documents/${documentId}?include=attachments`).then(res => {
            setInitialValues(res.data.form ?? defaultValues);
            if(res.data.form?.ai_report_pending){
                setAttachments([{id: null, size: null, file_name: "Cégértékelő.pdf", position: "ai", created_at: now()},...res.data.attachments]);
            } else {
                setAttachments(res.data.attachments ?? []);
            }
        }).catch(() => {
            navigate('/documents')
        })
    }, [documentId]);


    async function saveForm(form: Dictionary<any>) {
        const res = await axios.post(`/api/documents/${documentId}`, {form})
        setInitialValues(res.data.form ?? defaultValues);
        return res.status === 200;
    }
    async function reloadAttachments() {
        axios.get(`/api/documents/${documentId}?include=attachments`).then(res => {
            if(res.data.form?.ai_report_pending){
                setAttachments([{id: null, size: null, file_name: "Cégértékelő.pdf", position: "ai", created_at: now()},...res.data.attachments]);
            } else {
                setAttachments(res.data.attachments ?? []);
            }
        })
    }

    if (documentId) {
        if (initialValues === null) {
            return <EditorSkeleton/>
        }

        return (
            <Editor initialValues={initialValues} submit={saveForm} attachments={attachments}
                    setAttachments={setAttachments} reloadAttachments={reloadAttachments}/>
        )
    }
}

function EditorSkeleton() {
    return (
        <div className={'grid grid-cols-2 w-full h-full px-8 pb-10 gap-6 grid-rows-[1fr_3rem]'}>
            <div className={'w-full h-full flex flex-col gap-4 pt-32'}>
                <div className={"w-full animate-pulse h-12 bg-muted rounded"}></div>
                <div className={"w-full animate-pulse h-12 bg-muted rounded"}></div>
                <div className={"w-full animate-pulse h-12 bg-muted rounded"}></div>
                <div className={"flex gap-4"}>
                    <div className={"w-full animate-pulse h-12 bg-muted rounded"}></div>
                    <div className={"w-full animate-pulse h-12 bg-muted rounded"}></div>
                </div>
                <div className={"w-full animate-pulse h-12 bg-muted rounded"}></div>

            </div>
            <div className={'w-full h-full flex flex-col justify-center items-center gap-4'}>
                <div className={"max-w-full h-[70vh] aspect-[1/1.4714] bg-muted rounded animate-pulse"}></div>
            </div>
            <div className={"h-12 flex w-full gap-6 items-center justify-center"}>
                <div className={"w-12 animate-pulse h-12 bg-muted rounded"}></div>
                <div className={"w-12 animate-pulse h-12 bg-muted rounded"}></div>
                <div className={"w-12 animate-pulse h-12 bg-muted rounded"}></div>
            </div>
            <div className={"h-12 flex w-full gap-6 items-center justify-center"}>
                <div className={"w-24 animate-pulse h-12 bg-muted rounded"}></div>
            </div>
        </div>
    )
}